import HttpClient from "@/api/utils/HttpClient"

// Single staging RP instance - default it so deployed builds (which have no
// SO_REPORT_PORTAL_URL env var) still produce absolute deep-links; the env
// var remains an override. || not ??: empty-string means unset here.
const DEFAULT_RP_BASE_URL = "https://reportportal.staging.soenergy.co"

const baseUrl = (): string =>
  import.meta.env.SO_REPORT_PORTAL_URL || DEFAULT_RP_BASE_URL

// Deep-links only. ReportPortal's API sends no CORS headers for browser
// origins (verified via curl in the PR #1991 spike), so live status can't be
// fetched client-side. Reintroduce an API client only alongside the planned
// v2 server-side proxy.
export const rpLaunchesUrl = (project: string): string =>
  `${baseUrl()}/ui/#${project}/launches/all`

export interface RpExecution {
  id: number
  status: string
  startTime: number
  launchId?: number
}

export interface RpFilterResult {
  executions: RpExecution[]
  error: string | null
}

export interface RpLaunchRun {
  id: number
  number: number
  status: string
  startTime: string
  endTime: string | null
  passed: number
  failed: number
  skipped: number
  total: number
  triggeredBy: string | null
}

export interface RpLaunchesResult {
  runs: RpLaunchRun[]
  error: string | null
}

export interface RpStatusResponse {
  fetchedAt: string
  results?: Record<string, RpFilterResult>
  launches?: RpLaunchesResult
}

// Same-origin Vercel edge proxy (api/rp-status.ts) - it holds the RP token;
// the browser never talks to ReportPortal's API directly (no CORS headers).
const proxyClient = HttpClient({ baseURL: "/api", responseType: "json" })

export const fetchRpStatuses = async (
  filters: string[],
): Promise<RpStatusResponse> => {
  const response = await proxyClient.get<RpStatusResponse>(
    `rp-status?filters=${encodeURIComponent(filters.join(","))}`,
  )
  return response.data
}

export const fetchRpLaunches = async (
  count: number,
): Promise<RpStatusResponse> => {
  const response = await proxyClient.get<RpStatusResponse>(
    `rp-status?launches=${count}`,
  )
  return response.data
}

export const rpLaunchUrl = (project: string, launchId: number): string =>
  `${baseUrl()}/ui/#${project}/launches/all/${launchId}`
